<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <span
          class="btn btn-sm btn-danger float-left"
          v-if="client.deleted_at != null"
          >Deleted</span
        >

        <b-tabs>

          <b-tab title="Details">
             <table class="table">
          <table-row label="Name" :noBorder="true" :copyText="client.name">
            {{ client.name }}
          </table-row>

          <table-row label="Surname" :copyText="client.surname">
            {{ client.surname }}
          </table-row>

          <table-row label="Type">
            {{ client.client_type }}
          </table-row>

          <table-row label="Account Balance" v-if="client.account != null">
            <router-link
              v-b-tooltip.hover
              title="view account"
              :to="{
                name: 'accounts-account',
                params: { id: client.account.id },
              }"
              class="text-primary font-weight-bold"
            >
              <u> {{ client.account.current_balance  | currency }} </u>
            </router-link>
          </table-row>

          <table-row label="Partner" v-if="client.partner">
            {{ client.partner.name }}
          </table-row>

          <table-row label="ID Number" v-if="client.id_number">
            {{ client.id_number }}
          </table-row>

          <table-row label="Contact Number" :copyText="client.contact_number">
            {{ client.contact_number }}
          </table-row>

          <table-row label="Contact Number 2" v-if="client.contact_number_2">
            {{ client.contact_number_2 }}
          </table-row>

          <table-row label="Email" :copyText="client.email_address">
            {{ client.email_address }}
          </table-row>

          <table-row label="Address" class="nl2br" :copyText="client.address">{{
            client.address
          }}</table-row>

          <table-row label="City" :copyText="client.city">
            {{ client.city }}
          </table-row>

          <table-row label="Postal Code" :copyText="client.postal_code">
            {{ client.postal_code }}
          </table-row>

          <table-row
            label="Province"
            v-if="client.province"
            :copyText="client.province.province"
          >
            {{ client.province.province }}
          </table-row>

          <table-row label="Vat #" v-if="client.vat_number">
            {{ client.vat_number }}
          </table-row>

          <table-row label="Notes">
            {{ client.notes }}
          </table-row>

          <table-row icon="lni-database" :noBorder="true" />

          <table-row label="Id">
            {{ client.id }}
          </table-row>

          <table-row label="Created">
            {{
              moment(new Date(client.created_at)).format(
                "DD MMM YYYY, HH:mm:ss"
              )
            }}
          </table-row>
          <table-row label="Updated">
            {{
              moment(new Date(client.updated_at)).format(
                "DD MMM YYYY, HH:mm:ss"
              )
            }}
          </table-row>
        </table>
          </b-tab>

           <b-tab
              title="Current Jobs"
            >
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>Job</th>
                    <th>Status</th>
                    <th>Location</th>
                    <th></th>
                  </tr>
                </thead>
                <tr
                  v-for="job in client.current_jobs"
                  :key="job.id"
                >
                  <td>#{{ job.job_number }}</td>
                  <td>{{ job.job_status_location.status }}</td>
                  <td>{{ job.job_status_location.location }}</td>
                  <td class="text-right">
                    <router-link
                      v-b-tooltip.hover
                      title="view"
                      :to="{
                        name: 'jobs-enquiry-detailed',
                        params: { id: job.id },
                      }"
                      class="text-info table-action-icon"
                    >
                      <i class="lni lni-search-alt"></i>
                    </router-link>
                  </td>
                </tr>
              </table>
            </b-tab>
        </b-tabs>

       
      </b-col>
    </b-row>
  </div>
</template>

<script>
import clientRepo from "@/api/repos/clientRepo";
import tableRow from "@/components/common/TableRow";

export default {
  props: ["id"],

  components: {
    tableRow,
  },

  mounted() {
    this.getClient();
  },

  data() {
    return {
      loading: false,
      client: {},
    };
  },

  methods: {
    async getClient() {
      try {
        this.loading = true;
        let { data } = await clientRepo.get(this.id);
        this.client = data.client;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
